'use client';

import { atomWithStorage } from '@capsicum/common';

export const setProductQuantityAtom = atomWithStorage<number>('quantity', 0);
